import React, { useState, useEffect } from 'react';

// Delay per step while API is still running
const STEP_DELAY_MS = 2000;
// Delay per step once API has returned (flush remaining quickly)
const FLUSH_DELAY_MS = 500;

export function OrderProgressScreen({ apiComplete, onDone, hasVoip, hasAdditionalServices }) {
    const steps = [
        'Creating your customer account',
        'Configuring your broadband service',
        ...(hasVoip ? ['Setting up your phone service'] : []),
        ...(hasAdditionalServices ? ['Setting up your additional services'] : []),
        'Setting up your Direct Debit',
        'Sending your welcome email'
    ];

    const [completedSteps, setCompletedSteps] = useState(0);

    useEffect(() => {
        if (completedSteps >= steps.length) {
            if (apiComplete) onDone();
            return;
        }

        const delay = apiComplete ? FLUSH_DELAY_MS : STEP_DELAY_MS;
        const timer = setTimeout(() => setCompletedSteps(s => s + 1), delay);
        return () => clearTimeout(timer);
    }, [completedSteps, apiComplete, steps.length]);

    return (
        <div className="card selected">
            <div className="card-header">
                <div className="card-header-title is-centered">
                    <h2 className="subtitle is-5">Setting Up Your Order</h2>
                </div>
            </div>
            <div className="card-content">
                <div style={{ maxWidth: '360px', margin: '0 auto' }}>
                    {steps.map((step, index) => {
                        const done = index < completedSteps;
                        const active = index === completedSteps;
                        return (
                            <div key={index} className="is-flex is-align-items-center mb-4">
                                <span className="icon mr-3 is-flex-shrink-0">
                                    {done  && <i className="fas fa-check-circle fa-lg has-text-success"></i>}
                                    {active && <i className="fas fa-spinner fa-pulse fa-lg has-text-info"></i>}
                                    {!done && !active && <i className="far fa-circle fa-lg has-text-grey-lighter"></i>}
                                </span>
                                <span className={
                                    done   ? 'has-text-grey'       :
                                    active ? 'has-text-weight-semibold' :
                                             'has-text-grey-lighter'
                                }>
                                    {step}
                                </span>
                            </div>
                        );
                    })}
                </div>
                <p className="has-text-grey has-text-centered mt-5 is-size-7">
                    Please don&apos;t close this window &mdash; this may take a few moments.
                </p>
            </div>
        </div>
    );
}
